import React, {Suspense} from 'react';
import classNames from 'classnames';
import AppTopbar from 'containers/app/AppTopbar';
import {AppFooter} from 'containers/app/AppFooter';
import {AppMenu} from 'containers/app/AppMenu';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';
import 'layout/layout.scss';
import './App.scss';
import {FTUComponent} from 'components/FTUComponent';
import {withTranslation} from 'react-i18next';
import {AuthenticationService} from 'services/access/AuthenticationService';
import ContainerRouter from 'routes/ContainerRouter';
import {connect} from "react-redux";
import AppBreadcrumb from "components/Breadcrumb";
import routes from "routes/routes";
import {UserService} from "../../services/access/User";
import {fetchUser} from "../../reactRedux/action/userAction";
import {ReportService} from "../../services/report/ReportService";
import {stringNullOrEmpty} from "../../components/category/CommonUtils";
import {showWarningBox} from "../../components/MessageBox";

class App extends FTUComponent {

    constructor(props) {
        super(props);
        this.state = {
            //layoutMode: 'static',
            layoutMode: 'overlay',
            //layoutColorMode: 'dark',
            layoutColorMode: 'light',
            staticMenuInactive: false,
            overlayMenuActive: false,
            mobileMenuActive: false,
            appLgn: "vi",
            menu: null,
        };

        this.onWrapperClick = this.onWrapperClick.bind(this);
        this.onToggleMenu = this.onToggleMenu.bind(this);
        this.onSidebarClick = this.onSidebarClick.bind(this);
        this.onMenuItemClick = this.onMenuItemClick.bind(this);
    }

    componentWillMount() {
        this.createMenu();
    }

    componentDidMount() {
        const url = this.props.location ? this.props.location.pathname : "";
        AuthenticationService.logAccessPath(url);
        document.title = this.trans("app.title");
        AuthenticationService.restoreUserInfo();
        if (url.startsWith("/report/reportDynamic/")) {
            new ReportService().findReportByCode(url.substring(22, url.length)).then((res) => this.setState({menuName: res && res.data && res.data.body ? res.data.body : ""}));
        }
        /*this.timerRefreshTokenID = setInterval(
            AuthenticationService.refreshToken,
            APP_REFRESH_TOKEN_TIME
        );*/
    }

    componentWillUnmount() {
        //clearInterval(this.timerRefreshTokenID);
    }

    onWrapperClick(event) {
        if (!this.menuClick && (this.state.overlayMenuActive || this.state.mobileMenuActive)) {
            //HaiLQ3: ghi log truy cập chức năng
            // if (event.item && event.item.id) {
            //     AuthenticationService.logAccess(event.item.id);
            // }
            this.setState({
                overlayMenuActive: false,
                mobileMenuActive: false
            });
        }

        this.menuClick = false;
    }

    onToggleMenu(event) {
        this.menuClick = true;

        if (this.isDesktop()) {
            if (this.state.layoutMode === 'overlay') {
                this.setState({
                    overlayMenuActive: !this.state.overlayMenuActive
                });
            } else if (this.state.layoutMode === 'static') {
                this.setState({
                    staticMenuInactive: !this.state.staticMenuInactive
                });
            }
        } else {
            const mobileMenuActive = this.state.mobileMenuActive;
            this.setState({
                mobileMenuActive: !mobileMenuActive
            });
        }

        event.preventDefault();
    }

    onSidebarClick(event) {
        this.menuClick = true;
    }

    onMenuItemClick(event) {
        if (!event.item.children || !event.item.children.length) {
            this.setState({
                overlayMenuActive: false,
                mobileMenuActive: false
            })
        }
    }

    async createMenu() {
        //lay thong tin user
        let uInfor = await UserService.getUserInfor();
        if (uInfor && uInfor.data) {
            this.props.dispatch(
                fetchUser(uInfor.data)
            );
        }
        //lay menu
        let menu = await UserService.getMenu();
        await this.setState({
            menu: menu.tree,
            flat: menu.flat
        });
    }

    addClass(element, className) {
        if (element.classList)
            element.classList.add(className);
        else
            element.className += ' ' + className;
    }

    removeClass(element, className) {
        if (element.classList)
            element.classList.remove(className);
        else
            element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }

    isDesktop() {
        return window.innerWidth > 1024;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.location && this.props.location && prevProps.location.pathname != this.props.location.pathname) {
            AuthenticationService.logAccessPath(this.props.location.pathname);
            //call search
            let url = this.props.location.pathname;
            if (url.startsWith("/report/reportDynamic/")) {
                new ReportService().findReportByCode(url.substring(22, url.length)).then((res) => this.setState({menuName: res && res.data && res.data.body ? res.data.body : ""}));
            }
        }
        if (this.state.mobileMenuActive)
            this.addClass(document.body, 'body-overflow-hidden');
        else
            this.removeClass(document.body, 'body-overflow-hidden');
    }

    render() {
        /*START_Thay doi ngon ngu: ho tro tieng viet va tieng anh*/
        const {i18n} = this.props;
        const changeLanguage = (evt) => {
            if (this.state.appLgn === "vi") {
                i18n.changeLanguage("en");
                this.setState({
                    appLgn: "en"
                });
            } else {
                i18n.changeLanguage("vi");
                this.setState({
                    appLgn: "vi"
                });
            }

        };
        /*END_Thay doi ngon ngu: ho tro tieng viet va tieng anh*/
        //
        const logo = this.state.layoutColorMode === 'dark' ? process.env.PUBLIC_URL + '/assets/layout/images/mbf-logo.png' : process.env.PUBLIC_URL + '/assets/layout/images/mbf-logo.png';

        const wrapperClass = classNames('layout-wrapper', {
            'layout-overlay': this.state.layoutMode === 'overlay',
            'layout-static': this.state.layoutMode === 'static',
            'layout-static-sidebar-inactive': this.state.staticMenuInactive && this.state.layoutMode === 'static',
            'layout-overlay-sidebar-active': this.state.overlayMenuActive && this.state.layoutMode === 'overlay',
            'layout-mobile-sidebar-active': this.state.mobileMenuActive
        });

        const sidebarClassName = classNames("layout-sidebar", {
            'layout-sidebar-dark': this.state.layoutColorMode === 'dark',
            'layout-sidebar-light': this.state.layoutColorMode === 'light'
        });

        return (
            <div className={wrapperClass} onClick={this.onWrapperClick}>

                <AppTopbar onToggleMenu={this.onToggleMenu} onChangeLgn={changeLanguage}
                           appLgn={this.state.appLgn === "vi" ? "en" : "vi"} logo={logo}/>
                <div ref={(el) => this.sidebar = el} className={sidebarClassName} onClick={this.onSidebarClick}>
                    <div className="layout-logo">
                        <img alt="Logo" src={logo}/>
                    </div>
                    {/*<AppProfile />*/}
                    <AppMenu model={this.state.menu} validMenu={this.state.flat} onMenuItemClick={this.onMenuItemClick}/>
                </div>

                <div className="layout-main">
                    <Suspense fallback="loading">
                        <AppBreadcrumb appRoutes={routes} menuName={this.state.menuName}/>
                        <ContainerRouter/>
                    </Suspense>
                </div>

                <AppFooter/>

                <div className="layout-mask"></div>
            </div>
        );
    }
}

const
    mapStateToProps = state => ({
        user: state.user.info,
        example: state.example.exampleInfo
    });

export default withTranslation("common")(connect(mapStateToProps)(App));